import { render, staticRenderFns } from "./totalGarbageAnalysis.vue?vue&type=template&id=37abf61d&scoped=true"
import script from "./totalGarbageAnalysis.vue?vue&type=script&lang=js"
export * from "./totalGarbageAnalysis.vue?vue&type=script&lang=js"
import style0 from "./totalGarbageAnalysis.vue?vue&type=style&index=0&id=37abf61d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abf61d",
  null
  
)

export default component.exports